<app-navbar *ngIf="!auxiliarService.currentPathIncludes(['login'])"></app-navbar>
<div class="app-view" [ngClass]="{'logged': !auxiliarService.currentPathIncludes(['login']),
                                  'no-padding': auxiliarService.currentPathIncludes(['timesheet', 'holidays'])}">
  <router-outlet></router-outlet>
</div>

<!--transition page-->
<app-transition-page></app-transition-page>
<!--app toast-->
<p-toast key="toast"></p-toast>
